import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { translations } from "./i18n/translations";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Services } from "./components/site/Services";
import { About } from "./components/site/About";
import { WhyUs } from "./components/site/WhyUs";
import { Pricing } from "./components/site/Pricing";
import { Team } from "./components/site/Team";
import { Gallery } from "./components/site/Gallery";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { WhatsAppFAB } from "./components/site/WhatsAppFAB";

const Home = () => {
  const [lang, setLang] = useState("es");
  const t = translations[lang];

  return (
    <div className="App bg-zinc-950 text-zinc-50 min-h-screen" data-testid="site-root">
      <Nav lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} />
        <Marquee />
        <Services t={t} />
        <About t={t} />
        <WhyUs t={t} />
        <Pricing t={t} />
        <Team t={t} />
        <Gallery t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
      <WhatsAppFAB label={t.nav.whatsapp} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
